import type { IncidentDTO } from "../api/status";
import { IncidentSeverityBadge } from "./StatusBadge";

interface Props {
  items: IncidentDTO[];
  emptyText?: string;
}

function formatDuration(seconds: number | null): string {
  if (seconds === null) return "ongoing";
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  if (m < 60) return `${m}min`;
  const h = Math.floor(m / 60);
  const remM = m % 60;
  return remM > 0 ? `${h}h ${remM}min` : `${h}h`;
}

function fmt(iso: string): string {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export function IncidentList({ items, emptyText = "No incidents." }: Props): JSX.Element {
  if (items.length === 0) {
    return <p className="text-sm text-text-muted">{emptyText}</p>;
  }
  return (
    <ul className="divide-y divide-border">
      {items.map((i) => (
        <li key={i.id} className="space-y-1 py-3">
          <div className="flex flex-wrap items-center gap-2">
            <IncidentSeverityBadge severity={i.severity} />
            <span className="text-sm font-medium text-text-primary">{i.summary}</span>
            <span className="font-mono text-xs text-text-muted">{i.service}</span>
          </div>
          <div className="text-xs text-text-muted">
            Started {fmt(i.startedAt)}
            {" · "}duration {formatDuration(i.durationSeconds)}
            {i.endedAt && <> · ended {fmt(i.endedAt)}</>}
          </div>
        </li>
      ))}
    </ul>
  );
}
